// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tEf87","inner":"styles_inner__3aqNn","right":"styles_right__3IKZg","close":"styles_close__9Uj5x","footer":"styles_footer__rFRPz"};